export default __webpack_public_path__ + "static/media/4typesCard1.e2df2c0f.png";